import Vue from "vue";
import VueRouter from "vue-router";
import VTooltip from "v-tooltip";
import Notifications from "vue-notification";
import VueClipboard from "vue-clipboard2";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import PortalVue from "portal-vue";
import VuePapaParse from "vue-papa-parse";
import VueSanitize from "vue-sanitize";
//import VueMouseflow from 'vue-mouseflow';
require("./vendor/vue-shortkey/src");
window._ = require("lodash");
window.$ = window.jQuery = require("jquery");
//require('chartjs-chart-box-and-violin-plot/build/Chart.BoxPlot.mjs')
import "chartjs-chart-box-and-violin-plot/build/Chart.BoxPlot.js";

window.MathJax = {
  chtml: {
    fontURL:
      process.env.VUE_APP_APP_URL + "/mathjax/output/chtml/fonts/woff-v2", // The URL where the fonts are found
  },
};
require("mathjax/es5/tex-mml-chtml.js");
/*require('mathjax/jax/output/SVG/config.js?V=2.7.5')
require('mathjax/config/MML_HTMLorMML.js?V=2.7.5')
require('mathjax/jax/output/SVG/jax.js?V=2.7.5')
require('mathjax/jax/output/SVG/fonts/TeX/fontdata.js?V=2.7.5')
require('mathjax/jax/output/SVG/fonts/TeX/Size1/Regular/Main.js?V=2.7.5')
require('mathjax/extensions/MathMenu.js?V=2.7.5')
require('mathjax/extensions/MathZoom.js?V=2.7.5')
require('mathjax/extensions/MathML/content-mathml.js?V=2.7.5')
require('mathjax/extensions/MathML/mml3.js?V=2.7.5')*/
/*MathJax.Hub.Config({
  MathML: {
    extensions: ["content-mathml.js","mml3.js"]
  }
});*/
import "jquery-ui/ui/widgets/draggable.js";
import "jquery-ui/ui/widgets/resizable.js";
/*Font Awesome*/
window.Vue = require("vue").default;
Vue.use(VueRouter);
Vue.use(VTooltip);
Vue.use(Notifications);
Vue.use(VueClipboard);
Vue.component(VueQrcode.name, VueQrcode);
Vue.use(PortalVue);
Vue.use(VuePapaParse);
Vue.use(VueSanitize);
//Vue.use(VueMouseflow, { tracking_key: process.env.VUE_APP_MOUSEFLOW_KEY});
require("vue-resource");
require("bootstrap-sass");
Vue.use(window.ShortKey);
/*Dedicated Bus to handle events Parent to non Parent*/
window.Events = new (class {
  constructor() {
    this.vue = new Vue();
  }
  fire(event, data = null) {
    this.vue.$emit(event, data);
  }
  listen(event, callback) {
    this.vue.$on(event, callback);
  }
  off(event) {
    this.vue.$off(event);
  }
})();

window.axios = require("axios");
require("./axios_config");
require("./components/ui/bootstrap");
require("./components/forms/bootstrap");
require("./components/search/bootstrap");
require("./components/misc/bootstrap");

require("./components/zoom/bootstrap");

window.moment = require("moment");
require("moment-timezone/builds/moment-timezone.min.js");

//global mixins
import { globalMixins } from "./mixins/global";

Vue.mixin(globalMixins);

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from "laravel-echo"

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'your-pusher-key'
// });

if (!String.linkify) {
  String.prototype.linkify = function() {
    // http://, https://, ftp://
    var urlPattern = /\b(?:https?|ftp):\/\/[a-z0-9-+&@#\/%?=~_|!:,.;]*[a-z0-9-+&@#\/%=~_|]/gim;

    // www. sans http:// or https://
    var pseudoUrlPattern = /(^|[^\/])(www\.[\S]+(\b|$))/gim;

    // Email addresses
    var emailAddressPattern = /[\w.]+@[a-zA-Z_-]+?(?:\.[a-zA-Z]{2,6})+/gim;
    /*console.log( this
            .replace(urlPattern, '<a href="$&" target="_blank">$&</a>')
            .replace(pseudoUrlPattern, '$1<a href="http://$2" target="_blank">$2</a>')
            .replace(emailAddressPattern, '<a href="mailto:$&">$&</a>'))*/
    return this.replace(
      urlPattern,
      '<a href="$&" target="_blank" data-mce-ref="http://$2" data-mce-selected="inline-boundary">$&</a>'
    )
      .replace(
        pseudoUrlPattern,
        '$1<a href="http://$2" target="_blank"">$2</a>'
      )
      .replace(emailAddressPattern, '<a href="mailto:$&">$&</a>');
  };
}
